import React from "react";
import { useSelector } from "react-redux";

import EvokeActiveButtons from "./buttons/EvokeActiveButtons";
import EvokeProcessedButtons from "./buttons/EvokeProcessedButtons";
import ClinicActiveButtons from "./buttons/ClinicActiveButtons";
import ClinicReviewButtons from "./buttons/ClinicReviewButtons";
import ClinicProcessedButtons from "./buttons/ClinicProcessedButtons";

import { getFooterView } from "utils/footerView.util";
import {
  EVOKE_ACTIVE,
  CLINIC_ACTIVE,
  EVOKE_PROCESSED,
  CLINIC_PROCESSED,
  CLINIC_FOR_REVIEW,
} from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";

const BUTTONS_BY_VIEW = {
  [EVOKE_ACTIVE]: EvokeActiveButtons,
  [EVOKE_PROCESSED]: EvokeProcessedButtons,
  [CLINIC_ACTIVE]: ClinicActiveButtons,
  [CLINIC_FOR_REVIEW]: ClinicReviewButtons,
  [CLINIC_PROCESSED]: ClinicProcessedButtons,
};

const NoteButtons = ({ handleProcess, handleSignProcess }) => {
  const { reportDetail, reportCurrentTab } = useSelector(
    (state) => state.transmission
  );
  const { isArchiveReport } = useSelector((state) => state.archiveReport);

  const view = getFooterView({
    role: getCurrentUserRole(),
    report: reportDetail,
    reportState: reportCurrentTab,
    isArchiveReport,
  });

  const Buttons = BUTTONS_BY_VIEW[view];

  if (!Buttons) return null;

  return (
    <div className="view-pdf__notes-footer__actions">
      <Buttons
        handleProcess={handleProcess}
        handleSignProcess={handleSignProcess}
      />
    </div>
  );
};

export default NoteButtons;
